/**
 * Utility class for handling session storage operations.
 * Provides type-safe get/set operations with JSON serialization.
 */
export class SessionStorageUtil {
  static set(key: string, value: unknown) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  static get<TReturn = unknown>(key: string): TReturn | null {
    const value = window.sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  static delete(key: string) {
    window.sessionStorage.removeItem(key);
  }

  static clear() {
    window.sessionStorage.clear();
  }

  static get KEY_NAMES() {
    return {
      CUSTOM_EXPORT_INCLUDE_BOUNDARY: 'includeBoundary',
      CUSTOM_EXPORT_ABLINE_UUID: 'abLineUuid',
      SHARE_MANDATE_EMAIL: 'shareMandateEmail',
      LAST_USED_TAB_STATUS_SECTION: 'lastUsedTabStatusSection',
      LAST_ADDED_ONESOIL_DEVICE: 'lastAddedOnesoilDevice',
      LAST_ADDED_EXATREK_DEVICE: 'lastAddedExatrekDevice',
      LICENSES_OVERVIEW_SORT_BY_DATE: 'licensesOverviewSortByDate',
      STATUS_WIDGET_SELECTED_TAB: 'statusWidgetSelectedTab',
      GRAPES_ONBOARDING_DISMISSED_FARM_UUIDS:
        'grapesOnboardingDismissedFarmUuids',
      JP_TRIAL_MODAL_SHOWN: 'jpTrialModalShown',
      JP_TRIAL_RENEWAL_MODAL_SHOWN: 'jpTrialRenewalModalShown',
      JP_TRIAL_ENDING_MODAL_SHOWN: 'jpTrialEndingModalShown',
    } as const;
  }
}
